import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppWidget.css";

const WhatsAppWidget = () => {
  // ✅ Add country code (India = 91). Do not include "+".
  const phoneNumber = "919003992693"; // Example: +91 9003992693
  const message = "Hello! I’d like to know more about your courses."; // Default message

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppWidget;